import React, { Component } from 'react';

export default class Header extends Component {
    render() {
        return (
            <div>
                <h className="Title">Scale</h>
            </div>
        )
    }
}